import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalkMen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 17,
	viewBox: "0 0 12 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7.35849 3.30361C8.27273 3.30361 9.01386 2.56407 9.01386 1.6518C9.01386 0.739538 8.27273 0 7.35849 0C6.44426 0 5.70312 0.739538 5.70312 1.6518C5.70312 2.56407 6.44426 3.30361 7.35849 3.30361Z",
			fill: "#979797"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.17172 8.48259C8.3745 8.78652 8.67743 9.01695 9.02506 9.13258L11.2391 9.86928L11.763 8.30337L9.54899 7.56666L8.17255 5.50604C8.0124 5.26747 7.79313 5.07429 7.53606 4.94525L6.34916 4.35308C5.99606 4.17693 5.59128 4.13326 5.20861 4.23002L2.56582 4.88826C2.33386 4.94593 2.11714 5.053 1.93056 5.20212C1.74397 5.35124 1.59193 5.53888 1.48486 5.75216L0 8.71632L1.48073 9.4555L2.96559 6.49134L4.80553 6.03214L3.31239 12.9251L0.27148 15.0122L1.20925 16.3733L4.25098 14.2854C4.59944 14.0459 4.84112 13.6866 4.92968 13.2736L5.3576 11.3014L7.44088 12.8607L8.20648 16.6805L9.82957 16.3559L9.06396 12.5345C8.98358 12.1364 8.75905 11.7818 8.43327 11.5384L6.63637 10.1939L7.17188 6.98523L8.17172 8.48259Z",
			fill: "#979797"
		})
	]
});
const ForwardRef = forwardRef(SvgWalkMen);
export { ForwardRef as ReactComponent };
